import { render, staticRenderFns } from "./HeaderPicker.vue?vue&type=template&id=131c6b34&scoped=true&"
import script from "./HeaderPicker.vue?vue&type=script&lang=js&"
export * from "./HeaderPicker.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPicker.vue?vue&type=style&index=0&id=131c6b34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131c6b34",
  null
  
)

export default component.exports